import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import './App.css';

// Context
import { AuthProvider, useAuth } from './context/AuthContext';

// Pages
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import BackupPage from './pages/BackupPage';
import DailyBackupPage from './pages/DailyBackupPage';
import ImportPage from './pages/ImportPage';
import TasksPage from './pages/TasksPage';
import WipePage from './pages/WipePage';
import ResetCemeteryPage from './pages/ResetCemeteryPage';
import MediaUploadPage from './pages/MediaUploadPage';
import UnderConstructionPage from './pages/UnderConstructionPage';
import MapPreviewPage from './pages/MapPreviewPage';
import VerifyBackupPage from './pages/VerifyBackupPage';

// Components
import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import CommandPalette from './components/CommandPalette';

function AuthenticatedLayout({ user, onLogout }) {
  const [isPaletteOpen, setIsPaletteOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        setIsPaletteOpen(true);
      }
      if ((e.metaKey || e.ctrlKey) && ['1','2','3','4','5','6'].includes(e.key)) {
        e.preventDefault();
        const routes = ['/', '/backup', '/import', '/media-upload', '/tasks', '/wipe'];
        const idx = parseInt(e.key) - 1;
        navigate(routes[idx]);
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [navigate]);

  return (
    <>
      <Sidebar user={user} onLogout={onLogout} />
      <div className="app-content">
        <TopBar user={user} onLogout={onLogout} onOpenPalette={() => setIsPaletteOpen(true)} />
        <CommandPalette isOpen={isPaletteOpen} onClose={() => setIsPaletteOpen(false)} />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/backup" element={<BackupPage />} />
            <Route path="/backup/verify" element={<VerifyBackupPage />} />
            <Route path="/daily-backups" element={<DailyBackupPage />} />
            <Route path="/import" element={<ImportPage />} />
            <Route path="/media-upload" element={<MediaUploadPage />} />
            <Route path="/import/preview" element={<MapPreviewPage />} />
            <Route path="/tasks" element={<TasksPage />} />
            <Route path="/wipe" element={<WipePage />} />
            <Route path="/reset-cemetery" element={<ResetCemeteryPage />} />
            {/* legacy path redirect */}
            <Route path="/demo-reset" element={<Navigate to="/reset-cemetery" replace />} />
            <Route path="/construction" element={<UnderConstructionPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </>
  );
}

function AppRoutes() {
  const { user, loading, handleLogin, handleLogout } = useAuth();

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <Router>
      <div className="App">
        {user ? (
          <AuthenticatedLayout user={user} onLogout={handleLogout} />
        ) : (
          <Routes>
            <Route path="/login" element={<LoginPage onLogin={handleLogin} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        )}
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
